module.exports = __webpack_public_path__ + "static/media/portfolio 9.578f80a9.JPG";